<template>
  <div class="refill-overlay">
    <p class="small">
      The account balance will be reloaded with the Refill Amount whenever it dips
      below this Refill Threshold.
    </p>
    <ed-input type="money" amount v-model="RefillSettings.RefillThreshold" field-label="Refill Threshold" />
    <ed-input type="money" amount v-model="RefillSettings.RefillAmount" field-label="Refill Amount" />    
  </div>
</template>

<script>
export default {

  created() {
    this.getSettings()
  },

  methods: {
    async save() {
      try {
        const response = await this.api.patch(`evedpaycards/accounts/${this.accountId}/refill-settings`, {
          RefillSettings: this.RefillSettings
        })
        if (response.status === 200) {
          this.$emit('success')
        } else {
          console.log('Failed to refill. ' + response.status)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async getSettings() {
      try {
        const response = await this.api.get(`evedpaycards/accounts/${this.accountId}/refill-settings`)
        if (response.status === 200) {
          this.RefillSettings = response.data
          this.$emit('loaded')
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  props: {
    accountId: Number
  },

  data() {
    return {
      RefillSettings: { RefillAmount: null, RefillThreshold: null }
    }
  }
}
</script>

<style lang="scss" scoped>
  .refill-overlay {
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/AccountRefillSettings.vue